import jwtService from '@/services/common/jwt.service';
import $backgroundService from '@/services/common/background.service';

export class CompanyService {
  public async loadCompanies() {
    const user = await jwtService.getUser();
    const response = await $backgroundService.query(
      `admins/${user.id}/system/companies`
    );
    return response.data.data as string[];
  }
}

const companyService = new CompanyService();
export default companyService;
